import {
    AnimationBaseController,
    FullScreenManager,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/Game/GameModel';
import { ButtonController, IButtonControllerOptions } from '../../Common/ButtonController';
import { GameLogic } from '../../Logic/GameLogic';

import isMobile from 'is-mobile';

export class UIButtonTopController extends AnimationBaseController {
    $model: GameModel;
    private buttonSoundOff: ButtonController;
    private buttonSoundOn: ButtonController;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _fullScreenManager: FullScreenManager) {
        super('UIButtonTopController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {
                buttonFullScreen: {
                    instanceName: 'button_fullscreen',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            if (this._fullScreenManager.isEnabled) {
                                this._fullScreenManager.toggleGame();
                            }
                        },
                    },
                },
                buttonPause: {
                    instanceName: 'button_pause',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.showGamePause();
                        },
                    },
                },
                buttonMap: {
                    instanceName: 'button_map',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.showGameMiniMap();
                        },
                    },
                },
                buttonSoundOff: {
                    instanceName: 'button_sound_off',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.setSoundOnOff(true);
                            this._gameLogic.setMusicOnOff(true);

                            this.buttonSoundOff.visible = false;
                            this.buttonSoundOn.visible = true;
                        },
                    },
                },
                buttonSoundOn: {
                    instanceName: 'button_sound_on',
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.setSoundOnOff(false);
                            this._gameLogic.setMusicOnOff(false);

                            this.buttonSoundOff.visible = true;
                            this.buttonSoundOn.visible = false;
                        },
                    },
                },
            },
            modelWatch: {
                soundOnOff: () => {
                    this._changeState();
                },
            },
        };
    }

    protected onInitialize(): void {
        this.buttonSoundOff = this.$childControllers.get<ButtonController>('buttonSoundOff');
        this.buttonSoundOn = this.$childControllers.get<ButtonController>('buttonSoundOn');

        let buttonFullScreen = this.$childControllers.get<ButtonController>('buttonFullScreen');
        buttonFullScreen.visible = !isMobile() ? this._fullScreenManager.isEnabled : false;

        this._changeState();
    }

    private _changeState(): void {
        if (this._gameLogic.isSoundOnOff()) {
            this.buttonSoundOff.visible = false;
            this.buttonSoundOn.visible = true;
        } else {
            this.buttonSoundOff.visible = true;
            this.buttonSoundOn.visible = false;
        }
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.x = width / scale / 2;
        this.y = height / scale / 2 + (isMobile() ? 0 : -100);
    }
}

